import { PhoneIcon, UserGroupIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline'
import { Container } from '@/components/ui'

const ContactPage = () => {
  const contactMethods = [
    {
      name: 'Facebook Page',
      description: 'Theo dõi trang Facebook chính thức của M2MBA để cập nhật thông tin mới nhất về các khóa học, sự kiện và chia sẻ hữu ích.',
      url: 'https://www.facebook.com/profile.php?id=100063494024929',
      icon: ChatBubbleLeftRightIcon,
    },
    {
      name: 'Facebook Group',
      description: 'Tham gia nhóm Facebook để kết nối với cộng đồng học viên, chia sẻ kinh nghiệm và hỗ trợ lẫn nhau trong quá trình học tập.',
      url: 'https://www.facebook.com/groups/5436912959705537',
      icon: UserGroupIcon,
    },
    {
      name: 'Zalo',
      description: 'Liên hệ trực tiếp qua Zalo để được tư vấn nhanh chóng về khóa học, đăng ký và các thông tin hỗ trợ khác.',
      url: 'https://zalo.me/0983213076',
      icon: PhoneIcon,
    }
  ]

  const faqs = [
    {
      q: 'Làm thế nào để đăng ký khóa học?',
      a: 'Bạn có thể liên hệ trực tiếp qua Zalo hoặc Facebook để được tư vấn và hướng dẫn đăng ký chi tiết.',
    },
    {
      q: 'Có hỗ trợ học viên sau khóa học không?',
      a: 'Có, chúng tôi có nhóm Facebook hỗ trợ học viên và cộng đồng alumni để chia sẻ kinh nghiệm.',
    },
    {
      q: 'Thời gian phản hồi thường là bao lâu?',
      a: 'Chúng tôi thường phản hồi trong vòng 2-4 giờ trong giờ hành chính, và trong ngày đối với cuối tuần.',
    },
    {
      q: 'Có thể tư vấn qua điện thoại không?',
      a: 'Có, bạn có thể liên hệ qua Zalo để được tư vấn trực tiếp hoặc đặt lịch gọi điện thoại.',
    },
  ]

  return (
    <div className="bg-eh-cream eh-section">
      <Container>
        <div className="mx-auto max-w-2xl border-b border-eh-border pb-10 text-center">
          <p className="eh-eyebrow">Kết nối cùng M2MBA</p>
          <h1 className="eh-display">
            Liên hệ với chúng tôi
          </h1>
          <p className="mt-4 text-lg leading-8 text-eh-muted">
            Chúng tôi luôn sẵn sàng hỗ trợ bạn. Hãy kết nối với M2MBA qua các kênh sau để được tư vấn và hỗ trợ tốt nhất.
          </p>
        </div>

        <div className="mx-auto mt-12 max-w-5xl">
          <div className="eh-divider-list md:grid md:grid-cols-3 md:gap-0 md:border-t md:border-eh-border" role="list">
            {contactMethods.map((method) => (
              <article
                key={method.name}
                role="listitem"
                className="eh-divider-list__item md:border-r md:border-eh-border md:px-6 md:py-8 md:last:border-r-0"
              >
                <div className="mb-4 inline-flex h-11 w-11 items-center justify-center border border-eh-border bg-eh-sage/50 text-eh-forest-ink">
                  <method.icon className="h-5 w-5" aria-hidden="true" />
                </div>
                <h3 className="eh-heading mb-3">
                  {method.name}
                </h3>
                <p className="mb-6 text-sm leading-relaxed text-eh-muted">
                  {method.description}
                </p>
                <a
                  href={method.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="eh-btn w-full text-sm sm:w-auto"
                >
                  Kết nối ngay
                  <span className="eh-arrow" aria-hidden>→</span>
                </a>
              </article>
            ))}
          </div>
        </div>

        <div className="mx-auto mt-14 max-w-2xl border border-eh-border bg-eh-mint/40 px-6 py-8 text-center">
          <h2 className="eh-heading mb-3">
            Thời gian hỗ trợ
          </h2>
          <p className="mb-6 text-eh-muted">
            Chúng tôi sẵn sàng hỗ trợ bạn trong giờ hành chính để đảm bảo phản hồi nhanh nhất.
          </p>
          <div className="grid grid-cols-1 gap-4 text-sm text-eh-charcoal sm:grid-cols-2">
            <div>
              <p className="font-medium">Thứ 2 - Thứ 6</p>
              <p className="text-eh-muted">8:00 - 17:30</p>
            </div>
            <div>
              <p className="font-medium">Thứ 7 - Chủ nhật</p>
              <p className="text-eh-muted">9:00 - 16:00</p>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-14 max-w-4xl">
          <h2 className="eh-title mb-8 text-center">
            Câu hỏi thường gặp
          </h2>
          <div className="eh-divider-list" role="list">
            {faqs.map((faq) => (
              <div key={faq.q} className="eh-divider-list__item" role="listitem">
                <h3 className="eh-heading text-[1.1rem]">
                  {faq.q}
                </h3>
                <p className="mt-2 text-sm text-eh-muted">
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}

export default ContactPage
